import React, { useEffect, useState } from 'react';
import { FormControlLabel, Switch } from '@material-ui/core';
import { SelectSuppliersTable } from './SelectSuppliersTable';
import { useEditFormContext } from '../context';

export const SelectSuppliers = () => {
  const { selectedSuppliers, setSelectedSuppliers } = useEditFormContext();
  const [isSpecifySupplierEnabled, setIsSpecifySupplierEnabled] = useState(false);

  useEffect(() => {
    if (selectedSuppliers.length) {
      setIsSpecifySupplierEnabled(true);
    }
  }, [selectedSuppliers]);

  const handleSpecifySupplierChange = () => {
    setIsSpecifySupplierEnabled((prev) => !prev);
  };

  useEffect(() => {
    if (!isSpecifySupplierEnabled) {
      setSelectedSuppliers([]);
    }
  }, [isSpecifySupplierEnabled]);

  return (
    <section>
      <FormControlLabel
        control={<Switch checked={isSpecifySupplierEnabled} onChange={handleSpecifySupplierChange} value="all" />}
        label="Especificar fornecedores (Manter desativado irá considerar todos os fornecedores)"
      />
      {isSpecifySupplierEnabled && <SelectSuppliersTable />}
    </section>
  );
};
